import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
import { getGamePath } from './../../Utils/pathUtils.js';

import * as fJS from './../cjsRoot/fJS';
import { jsColor } from './../cjsRoot/jsColor';
import { cjsItem } from './../cjsRoot/cjsBase';
import STORE from '@/store';
import { cjsDraw } from '../cjsRoot/cjsDraw.js';

export class cjsMazeDraw extends cjsDraw {
  _drawCorrect;

  constructor(obj) {
    super(obj);
  }

  create() {
    super.create();

    if (!this.block) {
      this._lastPoint = new createjs.Point();

      this._point = {
        color:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          typeof this.otherProperty.maze.draw.color == 'string'
            ? this.otherProperty.maze.draw.color
            : typeof this._layout.background.color == 'string'
            ? typeof this._layout.background.color
            : false,
        start:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          typeof this.otherProperty.maze.draw.start == 'string'
            ? this.otherProperty.maze.draw.start
            : typeof this._layout.background.start == 'string'
            ? typeof this._layout.background.start
            : false,
        stop:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          typeof this.otherProperty.maze.draw.stop == 'string'
            ? this.otherProperty.maze.draw.stop
            : typeof this._layout.background.stop == 'string'
            ? typeof this._layout.background.stop
            : false,
        correct:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          typeof this.otherProperty.maze.draw.correct == 'string'
            ? this.otherProperty.maze.draw.correct
            : false,
        bridge:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          typeof this.otherProperty.maze.draw.bridge == 'string'
            ? this.otherProperty.maze.draw.bridge
            : false,
        size:
          typeof this.otherProperty.maze.draw != 'undefined' &&
          this.otherProperty.maze.draw != null &&
          fJS.isNumeric(this.otherProperty.maze.draw.size)
            ? this.otherProperty.maze.draw.size
            : 5,
      };

      if (this._point.color === false) throw 'Brakuje konfiguracji koloru rysowania';
      if (this._point.start === false) throw 'Brakuje konfiguracji koloru rozpoczęcia labiryntu';
    }
  }
}

cjsMazeDraw.checkGameAction = function (stage, droped) {
  console.log('cjsMazeDraw CHECK');

  let isCorrect = true;

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      if (item.block === true || item.point.stop === false) continue;
      if (item.trace.length === 0 && item.point.stop !== false) {
        isCorrect = false;
        continue;
      }
      let isOk = item.checkDrawMask(item.trace[item.trace.length - 1]),
        stop = new jsColor(item.point.stop);

      isCorrect = isOk === false || isOk.isSimilar(stop) !== true ? false : isCorrect;
      if (isCorrect === false) {
        console.log('correct: ' + isCorrect + ' - ' + isOk.RGBToString() + ' - STOP: ' + isOk.isSimilar(stop));
      } else console.log('GOOOOD');
    }
  }

  return isCorrect;
};

// SPRAWDZANIE CZY DOTARLIŚMY DO PRAWIDŁOWEGO TARGETU, BEZ SPRAWDZANIA MASKI
/*
cjsMazeDraw.checkGameAction = function(stage, droped) {
  console.log('cjsMazeDraw CHECK');

  let isCorrect = true,
    targets = {};
  // wyłapanie target'ów
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      item.isCorrect = false;

      if (item.block === false || item.thrown !== false) continue;
      if (typeof targets[gr] !== 'object' || targets[gr] === null) targets[gr] = {};
      targets[gr][i] = {
        items: [],
        correct: _.cloneDeep(item.correct),
      };
    }
  }

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];

      if (item.block === true && item.thrown === false) continue;

      if (item.thrown === false && item.correct.length === 0) {
        item.isCorrect = true;
        continue;
      }

      if (item.thrown === false) {
        continue;
      }
      let idx = -1;
      for (let j = 0; j < targets[item.thrown.idGroup][item.thrown.idItem].items.length; j++) {
        let check = targets[item.thrown.idGroup][item.thrown.idItem].items[j];

        if (check.idItem !== item.id || check.idGroup !== item.idGroup) continue;
        idx = j;
      }
      if (idx === -1) {
        targets[item.thrown.idGroup][item.thrown.idItem].items.push({
          idItem: item.id,
          idGroup: item.idGroup,
          count: 1,
          idSources: new Array(item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')),
        });
      } else {
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].count++;
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].idSources.push(
          item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')
        );
      }
    }
  }

  for (let gr in targets) {
    for (let i in targets[gr]) {
      targets[gr][i].isCorrects = 0;
      for (let j = 0; j < targets[gr][i].items.length; j++) {
        for (let k = 0; k < targets[gr][i].items[j].idSources.length; k++) {
          let it = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idSources[k]];
          for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
            if (targets[gr][i].correct[c1].idItem !== it.id) {
              continue;
            }

            if (fJS.isNumeric(targets[gr][i].correct[c1].count) !== true) {
              targets[gr][i].correct[c1].count = 1;
              let count = 0;
              for (let c2 = 0; c2 < targets[gr][i].correct.length; c2++) {
                if (targets[gr][i].correct[c2].idGroup === it.idGroup && targets[gr][i].correct[c2].idItem === it.id) {
                  count++;
                }
              }
              targets[gr][i].correct[c1].count = count;
            }
          }
        }
      }
    }
  }

  for (let gr in targets) {
    for (let i in targets[gr]) {
      let item = stage.groups[gr].items[i];
      // gdy target powinien pozostać pusty
      if (targets[gr][i].items.length === 0 && targets[gr][i].correct.length === 0) {
        item.isCorrect = true;
        continue;
      }

      for (let j = 0; j < targets[gr][i].items.length; j++) {
        for (let k = 0; k < targets[gr][i].items[j].idSources.length; k++) {
          let it = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idSources[k]];
          if ((it.correct.length === 0 && it.thrown !== false) || it.drawCorrect !== true) {
            continue;
          }

          for (let c = 0; c < it.correct.length; c++) {
            if (
              it.isEqual(it.correct[c], it.thrown, true) === false &&
              it.isEqual(fJS.removeProps('count')(it.correct[c]), it.thrown, true) === false
            ) {
              continue;
            }

            targets[gr][i].isCorrects = 0;
            for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
              if (fJS.isNumeric(targets[gr][i].correct[c1].count) === false) {
                continue;
              }
              if (
                targets[gr][i].correct[c1].idGroup === it.idGroup &&
                targets[gr][i].correct[c1].idItem === it.id &&
                targets[gr][i].correct[c1].count > 0
              ) {
                it.isCorrect = true;
                targets[gr][i].correct[c1].count--;
              }

              if (targets[gr][i].correct[c1].count > 0) continue;
              targets[gr][i].isCorrects++;
            }
            if (
              (targets[gr][i].pickCorrect !== false && targets[gr][i].isCorrects === targets[gr][i].pickCorrect) ||
              targets[gr][i].isCorrects === targets[gr][i].correct.length
            )
              stage.groups[gr].items[i].isCorrect = true;
          }
          if (it.isCorrect === true && stage.correctBlock === true && droped !== false) {
            it.block = true;
            continue;
          }
        }
      }
    }
  }

  if (isCorrect === false) return false;

  for (let gr in targets) {
    for (let i in targets[gr]) {
      isCorrect =
        stage.groups[gr].items[i].isCorrect === false
          ? false
          : targets[gr][i].isCorrects !== targets[gr][i].items.length
          ? false
          : isCorrect;
    }
  }

  return isCorrect;
};
*/

cjsMazeDraw.stageMouseDown = function (e, data) {
  console.log('cjsStage DOWN in cjsMazeDraw');

  let stage = data.cjsStage,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
  stage.itemMD = false;

  if (stage.mousedown === true) {
    stage.mousedown = false;
    e.stopPropagation();
    return false;
  }

  let engine = -1;

  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.block === true) continue;

      let isOk = item.checkDrawMask(pt);
      if (isOk === false) {
        continue;
      }

      if (isOk.isSimilar(new jsColor(item.point.start))) {
        if (item.trace.length > 0) {
          item.trace.splice(0, item.trace.length);
        }
        item.lastPoint = pt;
        item.trace.push(pt);
        engine = item;
        break;
      }

      for (let i = 0; i < item.trace.length; i++) {
        if (
          pt.x - item.trace[i].x > -item.point.size &&
          pt.x - item.trace[i].x < item.point.size &&
          pt.y - item.trace[i].y > -item.point.size &&
          pt.y - item.trace[i].y < item.point.size
        ) {
          item.trace.splice(i, item.trace.length);
          if (i > 0) {
            item.lastPoint = item.trace[i - 1];
          } else {
            item.lastPoint = pt;
            item.trace.push(pt);
          }
          engine = item;
          break;
        }
      }
    }
  }

  if (engine === -1) {
    console.log('nie znaleziono ITEM');
    e.stopPropagation();
    return false;
  }

  cjsMazeDraw.redraw(stage);

  engine.mousedown = true;
  stage.mousedown = true;
  stage.itemMD = { idGroup: engine.idGroup, id: engine.id };
  engine.drawCorrect = true;

  e.stopPropagation();
};

cjsMazeDraw.stageMouseMove = function (e, data) {
  let stage = data.cjsStage,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY)),
    engine = stage.itemMD !== false ? stage.groups[stage.itemMD.idGroup].items[stage.itemMD.id] : false;

  if (stage.mousedown !== true || engine === false || engine.mousedown !== true) {
    stage.mousedown = false;
    if (engine instanceof cjsMazeDraw) engine.mousedown = false;
    stage.itemMD = false;
    e.stopPropagation();
    return false;
  }

  let dx = pt.x - engine.trace[engine.trace.length - 1].x,
    dy = pt.y - engine.trace[engine.trace.length - 1].y,
    lineAngle = Math.atan2(dy, dx),
    spaceBetween = 1,
    distance = fJS.getDistance(
      pt.x,
      pt.y,
      engine.trace[engine.trace.length - 1].x,
      engine.trace[engine.trace.length - 1].y
    ),
    numDots = Math.floor(distance / spaceBetween);

  if (numDots > 0) {
    let partialDistance = distance / numDots,
      midPoint = false,
      increment = 0;
    for (let i = 0; i < numDots; i++) {
      let point = {
        x: Math.round(
          engine.trace[engine.trace.length - 1].x + Math.cos(lineAngle) * (increment + partialDistance * i)
        ),
        y: Math.round(
          engine.trace[engine.trace.length - 1].y + Math.sin(lineAngle) * (increment + partialDistance * i)
        ),
      };

      if (engine.checkDrawMask(point) !== false) {
        midPoint = point;
      } else {
        e.stopPropagation();
        return false;
      }

      increment = increment < partialDistance ? increment + 0.025 : 1;
    }

    if (midPoint === false) {
      e.stopPropagation();
      return false;
    } else {
      pt = midPoint;
    }
  }

  if (engine.checkDrawMask(pt) === false) {
    e.stopPropagation();
    return false;
  }

  engine.trace.push(pt);
  // console.log(engine.point);
  if (engine.point.correct !== false) {
    let isOk = engine.checkDrawMask(pt);
    let start = new jsColor(engine.point.start),
      correct = new jsColor(engine.point.correct),
      stop = new jsColor(engine.point.stop),
      bridge = new jsColor(engine.point.bridge);
    // console.log(isOk);
    let isCorrect =
      isOk.isSimilar(correct) === true
        ? true
        : engine.point.bridge !== false && isOk.isSimilar(bridge) === true
        ? true
        : engine.point.start !== false && isOk.isSimilar(start) === true
        ? true
        : engine.point.stop !== false && isOk.isSimilar(stop) === true
        ? true
        : false;
    engine.drawCorrect = isCorrect === false ? false : engine.drawCorrect;

    if (isCorrect === false) {
      console.log(
        'correct: ' +
          isCorrect +
          ' - ' +
          isOk.RGBToString() +
          ' - START: ' +
          isOk.isSimilar(start) +
          ' - CORRECT: ' +
          isOk.isSimilar(correct) +
          ' - BRIDGE: ' +
          isOk.isSimilar(bridge) +
          ' - STOP: ' +
          isOk.isSimilar(stop)
      );
    } else console.log('GOOOOD');
  }

  let shape = stage.drawing.children[0];
  shape.graphics.ss(engine.point.size, 'round').s(engine.point.color);
  shape.graphics.mt(engine.lastPoint.x, engine.lastPoint.y);
  shape.graphics.lt(pt.x, pt.y);

  engine.lastPoint = pt;

  stage.drawing.updateCache('source-over');

  shape.graphics.clear();

  e.stopPropagation();
};

cjsMazeDraw.stageMouseUp = function (e, data) {
  console.log('cjsStage UP in cjsMazeDraw');

  let stage = data.cjsStage,
    engine = false,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));

  stage.mousedown = false;
  if (stage.itemMD !== false) {
    engine = stage.groups[stage.itemMD.idGroup].items[stage.itemMD.id];
    if (engine instanceof cjsMazeDraw) {
      engine.trace.push(pt);
      engine.mousedown = false;
      engine.thrown = stage.getObjectUnderPoint(pt, false, true);
    }
  } else {
    e.stopPropagation();
    return;
  }
  stage.itemMD = false;

  if (stage.autoCheckAllCorrect === true && cjsMazeDraw.checkGameAction.call(this, stage, false) === true) {
    console.log('autoCheckAllCorrect');
    STORE.dispatch('checkGame');
  }
  e.stopPropagation();
};

cjsMazeDraw.redraw = function (stage) {
  stage.drawing.updateCache();
  let shape = stage.drawing.children[0];

  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.trace.length == 0) {
        continue;
      }
      for (let i = 0; i < item.trace.length; i++) {
        if (i + 1 >= item.trace.length) break;
        shape.graphics
          .ss(item.point.size, 'round')
          .s(item.point.color)
          .mt(item.trace[i].x, item.trace[i].y)
          .lt(item.trace[i + 1].x, item.trace[i + 1].y);
        stage.drawing.updateCache('source-over');
        shape.graphics.clear();
      }
      item.lastPoint = item.trace[item.trace.length - 1];
    }
  }
};

cjsMazeDraw.resetGameAction = function (stage) {
  console.log('cjsMazeDraw RESET');
  stage._stage.off('pressmove', stage.listener.pm);
};

cjsMazeDraw.afterLoadSamples = function (stage) {
  console.log('cjsMazeDraw afterLoadSamples');

  cjsDraw.afterLoadSamples(stage);

  stage.drawing.addChild(new createjs.Shape());
  stage.drawing.cache(0, 0, stage.width, stage.height);

  stage.drawing.listener = {
    md: stage.drawing.on('mousedown', cjsMazeDraw.stageMouseDown, null, false, {
      cjsStage: stage,
    }),
    pm: stage._stage.on('pressmove', cjsMazeDraw.stageMouseMove, null, false, {
      cjsStage: stage,
    }),
    pu: stage.drawing.on('pressup', cjsMazeDraw.stageMouseUp, null, false, {
      cjsStage: stage,
    }),
  };

  stage.stage.addChild(stage.drawing);
};
